export const themeColor = {
    colorRegalDarkBlue: "#003875",
    colorLightBlue: "#0074b9",
    colorSecondary: "#7b7b7b",
    colorGrey: "#7f7f7f",
    colorBlack: "#000",
    colorWhite: "#fff",
    colorAbbey: "#414345",
    colorRehino: "#333365",
    colorRegalLightBlue: "#003a74",
    colorErrorRed: "#e64e25",
    colorLightGrey: "#e9e9e9",
    colorBgRed: "#ffe4e1",
    colorBorderRed: "#8b0000",
    colorTextRed: "#8b0000",
    colorBgGreen: "rgba(39, 167, 74,0.15)",
    colorBorderGreen: "#27a74a",
    colorTextGreen: "#27a74a",
    colorPrimary: "#275AA8",
    colorPrimaryHover: "#1b3f76",
    colorBorderGrey: "#cccccc",
    colorSecondaryBlue: "#003876"
};
